import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { imsLoader, popCancelBttn, GenAiExcelIcon, GenAiDOCIcon, GenAiPDFIcon, GenAiPPTIcon, arrowIconBlue, DonutChart } from '../../assets/index';
import CreatePromptTemplatePopUp2 from "./CreatePromptTemplatePopUp2.0";
import ExistingPromptTemplatePopUp2 from "./ExistingPromptTemplatePopUp2.0";
import ExpandExistingPromptPopUpModal from './ExpandExistingPromptPopUpModal';

class PromptTemplateListPopUpAuth2 extends Component {
    constructor(props) {
        super(props);
        this.Listref = React.createRef()
        this.state = {
            newPrompts: [{ prompt: '', wordLimit: '' }],
            existingPrompts: this.props?.prompts ? this.props.prompts : [],
            originalPromptCount: 0,
            showPop: false,
            //newAddedPrompts: [{ prompt:'', wordLimit: ''}]
            errorMsg: {},
            selectedReadingLevel: "",
            readingLevel: ["8", "9", "10", "12"],
            visibleCount: 0,
            isExpanded: false,
            heightValue: 0,
            expandPromptTemplate: false,
            expandPromptContent: ''
        }
    }
    async componentDidMount() {
        this.setState({
            existingPrompts: this.props.prompts,
            originalPromptCount: this.props.prompts.length,
            showPop: this.props.showPromptTemplateList,
        }, () => {
            this.scrollToBottom();
        });
    }
     componentDidUpdate(prevProps, prevState) {
        if (prevState.isExpanded !== this.state.isExpanded) {
           window.requestAnimationFrame(()=>{ window.requestAnimationFrame(()=>{
            if (this.Listref.current) {
                const oneEleHeight = this.Listref.current.offsetHeight 
                const allEleHeight = oneEleHeight * this.state.existingPrompts.length - oneEleHeight
                this.setState({ heightValue: allEleHeight })
            }
        })
       
    })
}
}

    insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
    ]
    handleInputUserPromptTemplate = (index, value) => {
        let { newPrompts } = this.state;
        newPrompts[index].prompt = value;
        this.setState({
            newPrompts: newPrompts,
        })
    }
    handleInputUserPromptTemplate = (index, value) => {
        let { newPrompts } = this.state
        let createUserPromp = newPrompts
        //createUserPromp[index].id = index
        createUserPromp[index].prompt = value;
        this.setState({ newPrompts: createUserPromp })
    }
    handleRemoveUserPromptTemplate = (index) => {
        let { newPrompts } = this.state
        let createUserPromptTemplates = newPrompts.filter((x, i) => i != index);
        this.setState({ newPrompts: createUserPromptTemplates })
    }
    handleAddNewUserPromptTemplate = (index) => {
        let { newPrompts } = this.state
        let isLastIndex = newPrompts.length == index;
        let promptNew = this.insert(newPrompts, index, { prompt: "", wordLimit: '' })
        this.setState({ newPrompts: promptNew, }, () => {
            if (isLastIndex) {
                this.scrollToBottom();
            }
        })
    }
    handleInputWordLimit = (index, value) => {
        let { newPrompts } = this.state
        let promtNew = newPrompts;
        //promtNew[index].id = index
        promtNew[index].wordLimit = value;
        this.setState({ newPrompts: promtNew })
    }
    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    handleOnClickPromptTemplateExpand = (val) => {
        this.setState({ expandPromptTemplate: true , expandPromptContent: val })
    }
    handlePromptTemplate = (promptTemplateText) => {
        this.setState({  expandPromptTemplate: false , expandPromptContent: '' })
    }
    renderCreatePrompt = () => {
        let { newPrompts, existingPrompts, visibleCount, isExpanded } = this.state

        return (
            <div  className={"user-prompt-template-prompt-area gen-ai-authoring-authoring-prompt-area"} style={{ border: 'none', maxHeight: "calc(100vh - 295px)" }}>
                <>
                    <label className="prompt-fs-15">Existing Prompts</label>
                    <div ref ={this.Listref} className="user-prompt-template-wrapper" style={{ padding: "5px 5px 5px 0px" }}>
                        <div className="user-prompt-template-textArea">
                            <textarea className="user-prompt-template-list-textarea-box"
                                placeholder="Add Prompt Here"
                                value={existingPrompts[0].prompt}
                                disabled="true"
                            />
                        </div>
                        <div className="user-prompt-template-expand" onClick={()=>this.handleOnClickPromptTemplateExpand(existingPrompts[0].prompt)}>
                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </div>
                        <div >
                            <input className="user-prompt-word-limit" style={{ textAlign: 'center' }}
                                type="text"
                                value={existingPrompts[0].wordLimit}
                                disabled="true" />
                        </div>
                    </div>
                    <div className={''} style={{ height: (isExpanded) ? `${this.state.heightValue}px` : '0px', opacity: (isExpanded) ? '100' : '0',overflow:(isExpanded) &&'clip' }}>
                        {existingPrompts.slice(1, visibleCount).map((x, i) => {
                            return (
                                <ExistingPromptTemplatePopUp2
                                    key={`ExistingPromptTemplatePopUp-${i}-${Math.random()}`}
                                    promptTemplateText={x.prompt}
                                    wordLimit={x.wordLimit}
                                    errorMsg={''} />
                            )
                        })}
                    </div>
                
                    {existingPrompts.length > 0 && <>{(isExpanded) ?
                        <>
                            <span className='cbm-show-more-less user-prompt-button-show' onClick={() => this.setState({ visibleCount: 0, isExpanded: false })}>
                                Show Less Existing Prompt
                            </span>
                        </>
                        :
                        <>
                            <span className='cbm-show-more-less user-prompt-button-show' onClick={() => this.setState({ visibleCount: existingPrompts.length, isExpanded: true })}>
                                Show More Existing Prompt
                            </span>
                        </>
                    }
                    </>
                    }
                </>
                <>
                    <label className="prompt-fs-15">New Prompts</label>
                    {newPrompts.map((x, i) => {
                        return (
                            <CreatePromptTemplatePopUp2
                                key={`CreateUserPromptTemplate-${i}`} totalCounts={newPrompts.length}
                                handleInputUserPromptTemplate={this.handleInputUserPromptTemplate}
                                handleRemoveUserPromptTemplate={this.handleRemoveUserPromptTemplate}
                                handleAddNewUserPromptTemplate={this.handleAddNewUserPromptTemplate}
                                promptTemplateText={x.prompt}
                                currentIndex={i}
                                wordLimit={x.wordLimit}
                                isFromCreateProject={true}
                                handleInputWordLimit={this.handleInputWordLimit}
                                lastIndexOrininalPrompt={this.state.originalPromptCount - 1}
                                errorMsg={this.state.errorMsg} />
                        )
                    })}
                </>
                <div style={{ width: "100%" }}
                    ref={(el) => { this.messagesEnd = el; }}>
                </div>
            </div>
        )
    }
    handleValidation = (field, value) => {
        let { newPrompts } = this.state
        let errors = {};
        let isValid = true;
        if (field.startsWith('wordLimit')) {
            let filterError = newPrompts.map((val, index) => {
                if (!val.wordLimit || Number.isNaN(parseInt(val.wordLimit))) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter a numeric value.'
                    return (index)
                }
                else if (val.wordLimit < 50) {
                    isValid = false;
                    errors[`wordLimit${index}`] = '*Please enter word limit greater than 50.'
                    return (index)
                }
                else if(!val.prompt){
                    isValid = false;
                    errors[`prompt${index}`] = '*Prompt field is empty.'
                }
            }).filter(val => val)
            if (filterError.length > 0) {
                isValid = false
            }
        }
        this.setState({ errorMsg: errors })
        return (isValid)

    }
    onclickAddtoPromptTemplate = () => {
        let isValid = this.handleValidation('wordLimit')
        if (isValid) {
            let { newPrompts, selectedReadingLevel } = this.state

            let promt_New = newPrompts.filter(x => x.prompt).map(val => {
                return {
                    prompt: val.prompt,
                    wordLimit: val.wordLimit,
                    readingLevel: selectedReadingLevel
                }
            })
            this.props.processFollowUpMultiPrompts(promt_New);
        }

    }
    render() {
        let {expandPromptTemplate} = this.state
        return (
            <>
                <Modal
                    show={this.state.showPop}
                    size="xl"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="popup-transition prompt-templete-list-popup-transition"
                    className="z-index-prompt-templete-list"
                    backdropClassName="z-index-z-index-prompt-templete-list-backdrop"
                    scrollable={true}
                >
                    <div style={{ overflow: "auto" }}>
                        <div className="popup-cancel-btn-wrapper">
                            <img
                                src={popCancelBttn}
                                alt=""
                                onClick={(e) => {
                                    this.setState({ showPop: false });
                                    this.props.handleClose();
                                }}
                            />
                        </div>
                        {/* <div> */}
                        <Modal.Header
                            className="prompt-templete-list-gsfModalHeader"
                            style={{ justifyContent: "left" }}
                        >
                            <div
                                className="prompt-templete-list-head-body"
                                style={{
                                    textAlign: "center",
                                    width: "100%",
                                }}
                            >
                                <div
                                    className="prompt-templete-list-active-features-button"
                                >
                                    <span>Prompt Templates</span>
                                </div>
                                {/* </Modal.Title> */}
                            </div>

                        </Modal.Header>
                        <Modal.Body className="prompt-templete-authoring-templete-modal-body" scrollable={true}>
                            <div>
                                <div className="prompt-template-name-section">
                                    <div className="prompt-template-name-section-label prompt-fs-16" style={{ width: 'calc(100% - 110px)', textAlign: 'center' }}>
                                        Prompts
                                    </div>
                                    <div className="prompt-template-name-section-label prompt-fs-16">
                                        Word Limit
                                    </div>
                                </div>
                                {this.renderCreatePrompt()}
                                <div className='GenAIAuthoring-main-prompt-reading-level-container' style={{ flexDirection: 'row' , padding:'5px 0px',margin:'5px 0px' }}>
                                    <div className="GenAIAuthoring-div-label GenAIAuthoring-main-prompt-reading-level-label">Reading Level: </div>
                                    <select
                                        className="user-prompt-word-limit mx-0 wd-140 pd-2"
                                        onChange={(e) => { this.setState({ selectedReadingLevel: e.target.value }) }}
                                        value={this.state.selectedReadingLevel} >
                                        <option value=''>No Reading Level</option>
                                        {this.state.readingLevel.map((val) => {
                                            return <option value={val}>{val}th grade</option>
                                        })}
                                    </select>
                                </div>
                            </div>


                        </Modal.Body>
                    </div>
                    <Modal.Footer><div className="reading-list-button-wrapper prompt-templete-authoring-list-button-wrapper prompt-templete-list-gsf-popup-button-wrapper">
                        <button className="apply-prompt-template-button" type="button" onClick={(e) => this.onclickAddtoPromptTemplate()}  >Apply Prompt</button>
                        <button className="cancel-prompt-template-button" type="button" onClick={(e) => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                        }}  >Cancel</button>
                    </div></Modal.Footer>
                </Modal>
                {expandPromptTemplate && <ExpandExistingPromptPopUpModal placeholder='Add Prompt Here' content={this.state.expandPromptContent} showModal={expandPromptTemplate} isTextAreaDisable={true} handleSaveContent={this.handlePromptTemplate} />}
            </>
        );
    }
}
export default PromptTemplateListPopUpAuth2;